/**
 * Writes `value` to the system clipboard.
 *
 * @returns `true` on success, `false` if the Clipboard API rejects.
 */
export async function copyToClipboard(value: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    return false;
  }
}
